export const FREE_SERVICE_LABEL = 'Included';
export const NOT_OFFERED_LABEL = 'Not offered';
